// extracted by mini-css-extract-plugin
export default {"googleBtn":"YPMGDdh2ZkBUKeAWPqSX"};